import { MatBottomSheet } from "@angular/material/bottom-sheet"
import { BottomSheetConfirmationComponent } from "src/app/ui/components/bottom-sheet-confirmation/bottom-sheet-confirmation.component"
import { BottomSheetConfirmationDto } from "../models/dto/bottom-sheet-confirmation.dto"

export const confirmationBottomSheet = async (
  bottomSheet: MatBottomSheet,
  msg: string, 
  buttonCancelText: string, 
  buttonConfirmText: string,
  panelClassStyle: string
): Promise<boolean> => {

  const _data = {
    message: msg,
    btnCancelText: buttonCancelText,
    btnConfirmText: buttonConfirmText,
    isAgenda: true
  } as BottomSheetConfirmationDto

  const bottomSheetRef = bottomSheet.open(
    BottomSheetConfirmationComponent, {
      data: _data,
      panelClass: [panelClassStyle],
      disableClose: true
  })
  const t = await bottomSheetRef
    .afterDismissed()
    .toPromise() as BottomSheetConfirmationDto

  return t.confirmed
}
